import React from 'react'
import Accordion from '../components/Accordion'
import AccordionContent from '../components/AccordionContent'
import AccordionHeading from '../components/AccordionHeading'
import Button from '../components/Button'
import Zoomout from './Zoomout'
import { useGlobalContext } from '../services/DataMain'
import DOMHandler from '../hooks/DOMHandler'
import Hotspots from './Hotspots'


let finalId;
function Callouts(props) {

  // const DOMHandlerHelper = DOMHandler()
  // const { menuList } = useGlobalContext() || {}

//  if(props.id === "Remove the pedestal-callout"){
//   finalId = props.id.split(' ').join('');
//  }
//  else{
  finalId = props.id;
//  }

  return (
    <React.Fragment>
      {/* {props.hotspotVisibility && <div className='hotspot'></div> }  the temporary code */}

      
      <div className='calloutsContainer' id={finalId}>
      {/* <div className='calloutsContainer' id={finalId}> */}
     
      {/* <div className='hotspot'>
        {
          props.hotspotsData && props.hotspotsData.map((internalBtn, internalBtnindex) => {
            if(props.categoryCamSequence!= null) internalBtn.categoryCamSequence = props.categoryCamSequence;
            let productTitle = props.id.split("-");
            // console.log('productTitle===== ', productTitle[0])
            return (
              <React.Fragment key={internalBtnindex} >
                <Button 
                btnId={productTitle[0]+"-"+internalBtn.hotspotText.replace(/\s/g, '')+"-btn"}
                data={internalBtn}
                clickFunction={DOMHandlerHelper.hotspotClick} 
                classList="calloutInternalBtn" 
                >{internalBtn.hotspotText}</Button>
              </React.Fragment>
            )
          })
        }
      </div> */}

      {/* <Hotspots></Hotspots> */}

        <div className='menuAccordionCallouts'>
          <Button data={props} clickFunction={props.handleCalloutsInfo} classList="closeCallouts">&#10005;</Button>

          <ul className="menuAccordionList">
            {
              props?.menuItemCallout?.map((accordionItem, accordionItemIndex) => {
                
                // console.log("accordionItem.camera",accordionItem.camera)
                // console.log("whiteBubbleHotspot",accordionItem.whiteBubbleHotspot)

                return (
                  <li className="accordionItem" key={props.id + accordionItemIndex}>
                    <Accordion>
                      <AccordionHeading
                        id={props.id + accordionItemIndex}
                        ClickAcc={props.calloutAccFunc}
                        calloutAccShowHide={props.calloutAccShowHide}
                        iconName="caret-forward"
                        CategoryTitile={accordionItem.calloutHeading}
                        hotspotCamera={accordionItem.camera}
                        whiteBubbleHotspot={accordionItem.whiteBubbleHotspot}
                        >  
                        </AccordionHeading>

                      <AccordionContent
                        id={props.id + accordionItemIndex + "content"}
                      >
                        {/* <p>{window.decodeURIComponent(accordionItem.calloutContent)}</p> */}
                        <p>{accordionItem.calloutContent}</p>
                        {/* `<p>${accordionItem.calloutContent}</p>`; */}
                      </AccordionContent>

                    </Accordion>
                  </li>
                )
              })
            }



          </ul>
        </div>

        <Zoomout
         clickFunction={props.clickFunction}
         productStateSelectContext={props.productStateSelectContext}
         
         ></Zoomout>

      </div>

    </React.Fragment>
  )
}

export default Callouts;

{/* {
              // 1
              props.menuItemCallout.map((callout_content, callout_index) => {

                console.log("^%^%^%^", callout_content);
                return (


                  callout_content.items.map((calloutInt, calloutInternalIndex) => {
                    console.log(calloutInt, "callout internal data")
                    return (


                      calloutInt.callouts.map((calloutLevelone, calloutLeveloneIndex) => {

                        console.log("the calloutLevel one is", calloutLevelone);

                        return (

                          <li className="accordionItem" key={calloutLeveloneIndex}>
                            <Accordion>
                              <AccordionHeading
                                id={props.id + 'somthing'}
                                ClickAcc={props.calloutAccFunc}
                                calloutAccShowHide={props.calloutAccShowHide}
                                iconName="caret-forward"
                                // CategoryTitile={props.calloutLevelone}
                                CategoryTitile={calloutLevelone.calloutHeading}
                              >
                              </AccordionHeading>

                              <AccordionContent>
                                <p>{calloutLevelone.calloutContent}</p>
                              </AccordionContent>
                            </Accordion>
                          </li>

                        )
                      })


                    )
                  })


                )
              })
            } */}


{/* {
              // 1
              props.menuItemCallout.map((callout_content, callout_index) => {

                console.log("^%^%^%^", callout_content);
                return (
                        <li className="accordionItem" key={callout_index}>
                            <Accordion>
                              <AccordionHeading
                                id={props.id + callout_content.calloutHeading.replace(/\s/g, '')}
                                ClickAcc={props.calloutAccFunc}
                                calloutAccShowHide={props.calloutAccShowHide}
                                iconName="caret-forward"
                                // CategoryTitile={props.calloutLevelone}
                                CategoryTitile={callout_content.calloutHeading}
                              >
                              </AccordionHeading>

                              <AccordionContent>
                                <p>{callout_content.calloutContent}</p>
                              </AccordionContent>
                            </Accordion>
                          </li>


                  // callout_content.items.map((calloutInt, calloutInternalIndex) => {
                  //   console.log(calloutInt, "callout internal data")
                  //   return (


                  //     calloutInt.callouts.map((calloutLevelone, calloutLeveloneIndex) => {

                  //       console.log("the calloutLevel one is", calloutLevelone);

                  //       return (

                          
                  //       )
                  //     })


                  //   )
                  // })


                )
              })
            } */}